module.exports = __webpack_public_path__ + "img/jindong.7fe0dfe9.png";